import request from './request.js'

export default {
    orderForShipment(_data){  //商品订单发货
        return request({
            url:'/system/order/orderForShipment?data='+ JSON.stringify(_data),
            method:'post',
        })
    },
}